import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import PetListings from './components/PetListings';
import DealOfTheWeek from './components/DealOfTheWeek';
import AllProduct from './components/AllProducts';
import Blog from './components/Blog';
import HeartOfTheStory from './components/HeartOfTheStory';
import Funeral from './components/Funeral';
import Footer from './components/Footer';
import BlogDetail from "./components/Blog-Detail";
import AllDogBreed from './components/AllDogBreed';
import TermsAndConditions from './components/TermsAndConditions';
import PetDetails from './components/PetDetails';
import "bootstrap/dist/css/bootstrap.min.css";

const App = () => {
  return (
  <>
      <Helmet>
  <title>PetCrew | Expert Pet Grooming & Care Services in India</title>
  <meta name="description" content="India's most trusted platform for pet grooming, walking, boarding, and food. Serving thousands of happy pets with love and expertise." />
  <meta name="keywords" content="pet grooming, pet walking, pet care services, dog boarding, pet services India, PetCrew" />
</Helmet>

    <Router>
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <Hero />
                <PetListings />
                <DealOfTheWeek />
                {/* <AllProduct /> */}
                <Blog />
                <Footer />
              </>
            }
          />
          <Route path="/heart-of-the-story" element={<HeartOfTheStory />} />
          <Route path="/all-dog-breed" element={<AllDogBreed />} />
          <Route path="/funeral" element={<Funeral />} />
          {/* <Route path="/blog/:slugAndId" element={<BlogDetail />} /> */}
          {/* <Route path="/blog/:postId/:slug" element={<BlogDetail />} /> */}
          <Route path="/blog-detail/:id/:slug" element={<BlogDetail />} />
          {/* <Route path="/blog-detail/:postId/:slug" element={<BlogDetail />} /> */}

          <Route path="/food" element={<AllProduct />} />
          <Route path="https://petcrew.in/terms-condition.php " element={<TermsAndConditions />} />
          <Route path="/pet-detail/:id" element={<PetDetails />} />
          <Route path="/all-dog-breed" element={<PetListings />} />
          {/* <Route path="/team" element={<OurTeam />} />
          <Route path="/about" element={<About />} /> */}
        </Routes>
      </div>
    </Router>
</>
    // <div>
    //   <Header />
    //   <Hero />
    //   <PetListings />
    //   <DealOfTheWeek />
    //   <AllProduct />
    //   <Blog />
    //   {/* <Testimonial /> */}
    //   <Footer /> 
    // </div>
  );
};

export default App;
